module.exports = __webpack_public_path__ + "static/media/webhook-system.040ba6de.png";